import { FC } from "react";
import "./QRSkeleton.css";

const QRSkeleton: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="213"
      height="214"
      viewBox="0 0 213 214"
      fill="none"
      className="qr-pulse"
    >
      <path
        d="M80.4821 42.1502H48.719C45.7412 42.1502 43.4251 44.7971 43.4251 47.4441V79.2072C43.4251 82.185 45.7412 84.5011 48.719 84.5011H80.4821C83.1291 84.5011 85.776 82.185 85.776 79.2072V47.4441C85.776 44.7971 83.1291 42.1502 80.4821 42.1502ZM48.719 31.5625H80.4821C89.0847 31.5625 96.3637 38.8416 96.3637 47.4441V79.2072C96.3637 88.1406 89.0847 95.0888 80.4821 95.0888H48.719C39.7856 95.0888 32.8374 88.1406 32.8374 79.2072V47.4441C32.8374 38.8416 39.7856 31.5625 48.719 31.5625ZM80.4821 126.852H48.719C45.7412 126.852 43.4251 129.499 43.4251 132.146V163.909C43.4251 166.887 45.7412 169.203 48.719 169.203H80.4821C83.1291 169.203 85.776 166.887 85.776 163.909V132.146C85.776 129.499 83.1291 126.852 80.4821 126.852ZM48.719 116.264H80.4821C89.0847 116.264 96.3637 123.543 96.3637 132.146V163.909C96.3637 172.842 89.0847 179.791 80.4821 179.791H48.719C39.7856 179.791 32.8374 172.842 32.8374 163.909V132.146C32.8374 123.543 39.7856 116.264 48.719 116.264ZM133.421 42.1502C130.443 42.1502 128.127 44.7971 128.127 47.4441V79.2072C128.127 82.185 130.443 84.5011 133.421 84.5011H165.184C167.831 84.5011 170.478 82.185 170.478 79.2072V47.4441C170.478 44.7971 167.831 42.1502 165.184 42.1502H133.421ZM117.539 47.4441C117.539 38.8416 124.487 31.5625 133.421 31.5625H165.184C173.786 31.5625 181.065 38.8416 181.065 47.4441V79.2072C181.065 88.1406 173.786 95.0888 165.184 95.0888H133.421C124.487 95.0888 117.539 88.1406 117.539 79.2072V47.4441ZM117.539 121.558C117.539 118.911 119.855 116.264 122.833 116.264H144.008C146.655 116.264 149.302 118.911 149.302 121.558V144.057H170.478V121.558C170.478 118.911 172.794 116.264 175.772 116.264C178.419 116.264 181.065 118.911 181.065 121.558V149.351C181.065 152.329 178.419 154.645 175.772 154.645H144.008C141.031 154.645 138.715 152.329 138.715 149.351V126.852H128.127V177.144C128.127 180.121 125.48 182.438 122.833 182.438C119.855 182.438 117.539 180.121 117.539 177.144V121.558ZM61.9536 55.3849H67.2475C69.8944 55.3849 72.5414 58.0318 72.5414 60.6787V65.9726C72.5414 68.9504 69.8944 71.2664 67.2475 71.2664H61.9536C58.9758 71.2664 56.6598 68.9504 56.6598 65.9726V60.6787C56.6598 58.0318 58.9758 55.3849 61.9536 55.3849ZM56.6598 145.38C56.6598 142.734 58.9758 140.087 61.9536 140.087H67.2475C69.8944 140.087 72.5414 142.734 72.5414 145.38V150.674C72.5414 153.652 69.8944 155.968 67.2475 155.968H61.9536C58.9758 155.968 56.6598 153.652 56.6598 150.674V145.38ZM146.655 55.3849H151.949C154.596 55.3849 157.243 58.0318 157.243 60.6787V65.9726C157.243 68.9504 154.596 71.2664 151.949 71.2664H146.655C143.678 71.2664 141.362 68.9504 141.362 65.9726V60.6787C141.362 58.0318 143.678 55.3849 146.655 55.3849ZM138.715 169.203C138.715 166.556 141.031 163.909 144.008 163.909H149.302C151.949 163.909 154.596 166.556 154.596 169.203V174.497C154.596 177.475 151.949 179.791 149.302 179.791H144.008C141.031 179.791 138.715 177.475 138.715 174.497V169.203ZM170.478 163.909H175.772C178.419 163.909 181.065 166.556 181.065 169.203V174.497C181.065 177.475 178.419 179.791 175.772 179.791H170.478C167.5 179.791 165.184 177.475 165.184 174.497V169.203C165.184 166.556 167.5 163.909 170.478 163.909Z"
        fill="url(#paint0_linear_16086_210344)"
        style={{}}
      />

      <defs>
        <linearGradient
          id="paint0_linear_16086_210344"
          x1="84.5"
          y1="198"
          x2="116"
          y2="-13.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0.506012"
            stopColor="#DADADA"
            style={{
              stopColor: "#DADADA",
              stopOpacity: 1,
            }}
          />

          <stop
            offset="1"
            stopColor="#7F7F7F"
            style={{
              stopColor: "#7F7F7F",
              stopOpacity: 1,
            }}
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default QRSkeleton;
